<form (ngSubmit)="onSubmit()"
      [formGroup]="formSearcher"
      [ngClass]="{
                      'w-[400px]': !!formSearcher.controls.search.value,
                      'w-[200px]': !formSearcher.controls.search.value
                    }" class="transition-[width] ease-in-out delay-150
                           hover:w-[400px] focus:w-[400px] active:w-[400px]">
  <mat-form-field appearance="fill" class="w-full">
    <mat-icon matPrefix svgIcon="mat_outline:search"></mat-icon>
    <mat-label>Buscador</mat-label>
    <input formControlName="search" matInput>
    <mat-icon (click)="onReset()" *ngIf="formSearcher.controls.search.value"
              matSuffix
              svgIcon="mat_outline:cancel"></mat-icon>
  </mat-form-field>
</form>
